import { unimarcFields } from './book'

export const composerFields = `
firstName
lastName
resume: shortDescriptionFr
resumeEn: shortDescriptionEn
resume(lang: $lang)
img {
  url
  alt
}
slug
`
const numericDocumentFields = `
id
slug
title: titleFr
titleEn: titleEn
updateDate: updateDate
text: textFr_html
textEn: textEn_html
resume: shortDescriptionFr
resumeEn: shortDescriptionEn
translationStatus
publishingStartDate
source
authors {
  firstName
  lastName
}
copyrights {
  name: nameC
}
translators {
  username
  firstName
  lastName
}
`

type TypeIncludes =
  | 'books'
  | 'partitions'
  | 'monographs'
  | 'works'
  | 'articles'
  | 'audios'
  | 'videos'
  | 'biography'
  | 'workcourse'
  | 'analyses'
  | 'floraAudios'

export const mediasFields = `
id
slug
title
description
duration
type
timestamp`

export const getPersonBySlug = (include?: TypeIncludes) => {
  return `query getPersonBySlug($slug: String!) {
    personBySlug(slug: $slug) {
      firstName
      lastName
      privateState
      biographyDate
      resume: shortDescriptionFr
      resumeEn: shortDescriptionEn
      resources: documentaryresourcesText
      catalogueSource
      manualUpdateDate
      documents{
        id,
        slug,
        title,
        titleFr,
        titleEn
        publishingStartDate
        authors{firstName, lastName}
        copyrights{nameC}
      }
      photo {
        getUrl
      }
      copyrights
      slug
      hasArticles
      ${include === 'articles'
      ? `articles {
        id
        title
        url
        reference
        abstract
      }`
      : ''
    }
      type
      hasWorks
      ${include === 'works'
      ? `works {
        id
        slug
        title
        duration
        publishingStartDate
        publishingEndDate
        descriptionFr
        descriptionEn
        cardDescription
        style
        styleEn
        tags {
          label
        }
      }`
      : ''
    }
    hasBiography
      ${include === 'biography'
      ? `biography {
        ${numericDocumentFields}
      }`
      : ''
    }
    hasWorkcourse
      ${include === 'workcourse'
      ? `workcourse {
        ${numericDocumentFields}
      }`
      : ''
    }
      hasAnalyses
      ${include === 'analyses'
      ? `analyses {
        title
        text
        textFr
        textEn
        date
        type
        slug
        image {
          getUrl
        }
      }`
      : ''
    }
      hasBooks
      ${include === 'books'
      ? `books {
        ${unimarcFields}
      }`
      : ''
    }
      hasMonographs
      ${include === 'monographs'
      ? `monographs {
        ${unimarcFields}
      }`
      : ''
    }
      hasPartitions
      ${include === 'partitions'
      ? `partitions {
        ${unimarcFields}
      }`
      : ''
    }
      hasFloraAudios
      ${include === 'floraAudios'
      ? `floraAudios {
        ${unimarcFields}
      }`
      : ''
    }
    hasAudios
    ${include === 'audios'
      ? `
      audios {
        ${mediasFields}
      }
      `
      : ''
    }
    hasVideos
${include === 'videos'
      ? `
      videos {
        ${mediasFields}
      }
      `
      : ''
    }
    }
  }`
}
export const getComposers = () => {
  return ` {
    persons {
      id
      firstName
      lastName
    }
  }`
}

export const composerMinMaxDates = () => {
  return `query composerMinMaxDates {
    personMinMaxDate{
      birthDate{
        min,
        max
      }
      deathDate{
        min,
        max
      }
    }
  }`
}
export const getPersonByOldId = (include?: TypeIncludes) => {
  return `query getPersonByOldId($oldId: String!) {
    personByOldId(oldId: $oldId) {
      firstName
      lastName
      privateState
      biographyDate
      resume: shortDescriptionFr
      resumeEn: shortDescriptionEn
      resources: documentaryresourcesText
      catalogueSource
      manualUpdateDate
      documents{
        id,
        slug,
        title,
        titleFr,
        titleEn
        publishingStartDate
        authors{firstName, lastName}
        copyrights{nameC}
      }
      photo {
        getUrl
      }
      copyrights
      slug
      hasArticles
      ${include === 'articles'
      ? `articles {
        id
        title
        url
        reference
        abstract
      }`
      : ''
    }
      type
      hasWorks
      ${include === 'works'
      ? `works {
        id
        slug
        title
        duration
        publishingStartDate
        publishingEndDate
        descriptionFr
        descriptionEn
        cardDescription
        style
        styleEn
        tags {
          label
        }
      }`
      : ''
    }
    hasBiography
      ${include === 'biography'
      ? `biography {
        ${numericDocumentFields}
      }`
      : ''
    }
    hasWorkcourse
      ${include === 'workcourse'
      ? `workcourse {
        ${numericDocumentFields}
      }`
      : ''
    }
      hasAnalyses
      ${include === 'analyses'
      ? `analyses {
        title
        text
        textFr
        textEn
        date
        type
        slug
        image {
          getUrl
        }
      }`
      : ''
    }
      hasBooks
      ${include === 'books'
      ? `books {
        ${unimarcFields}
      }`
      : ''
    }
      hasMonographs
      ${include === 'monographs'
      ? `monographs {
        ${unimarcFields}
      }`
      : ''
    }
      hasPartitions
      ${include === 'partitions'
      ? `partitions {
        ${unimarcFields}
      }`
      : ''
    }
      hasFloraAudios
      ${include === 'floraAudios'
      ? `floraAudios {
        ${unimarcFields}
      }`
      : ''
    }
    hasAudios
    ${include === 'audios'
      ? `
      audios {
        ${mediasFields}
      }
      `
      : ''
    }
    hasVideos
${include === 'videos'
      ? `
      videos {
        ${mediasFields}
      }
      `
      : ''
    }
    }
  }`
}

export const personsByKey = () => {
  return `query personsByKey($key: String, $limit:Int, $offset:Int) {
  personsByKey(key: $key, limit: $limit, offset: $offset) {
    keys
    total
    persons {
      firstName
      lastName
      slug
      birthDate
      deathDate
      hasWorkcourse
      hasBiography
    }
  }
  }`
}
